import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router';
import { selectAuthStatus } from './AuthStore';

export interface RequireSignInProps {
  children: ReactNode;
}

/**
 * QZ-D18: every page but sign-in is for a signed-in admin. A signed-out visit
 * goes to `/signin`, carrying where it came from; an `unknown` status (the
 * session not yet restored) renders nothing.
 */
export const RequireSignIn = ({ children }: RequireSignInProps) => {
  const status = useSelector(selectAuthStatus);
  const location = useLocation();

  if (status === 'unknown') {
    return null;
  }
  if (status === 'signedOut') {
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }
  return <>{children}</>;
};

export default RequireSignIn;
